import InfoBlock from '@anm/components/InfoBlock';
import PasswordCheckListContent from '@anm/components/form/PasswordBlock/PasswordCheckListContent';
import { RequiredPasswordField } from '@anm/components/form/fields';
import isMobile from '@anm/helpers/is/isMobile';
import isValidPassword from '@anm/helpers/is/isValidPassword';
import { FC } from 'react';
import { FieldProps } from 'react-final-form';
import { CSSProp } from 'styled-components';

type PasswordParams = {
  password: string;
  errors: { [key: string]: string } | undefined;
  touched: { [key: string]: boolean } | undefined;
  activeField?: string;
  infoBlockStyles?: CSSProp;
};

type PasswordBlockProps = Partial<FieldProps<string, HTMLInputElement>> & PasswordParams;

const PasswordBlock: FC<PasswordBlockProps> = ({
  name = 'password',
  errors,
  touched,
  password = '',
  direction,
  activeField,
  infoBlockStyles,
  ...fieldProps
}) => {
  const showOnMobile = isMobile() ? !isValidPassword(password) : true;

  const canShow = (touched?.[name] && errors?.[name] === ' ') || (activeField === name && showOnMobile);

  return (
    <InfoBlock
      canShow={canShow}
      renderContent={() => <PasswordCheckListContent newPassword={password} />}
      styles={infoBlockStyles}
      direction={direction}
    >
      <RequiredPasswordField maxLength={60} {...{ name, ...fieldProps }} />
    </InfoBlock>
  );
};

export default PasswordBlock;
